import { useState, useMemo } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { putTTSSettings } from "../../service";
import { message } from "antd";
import { basicPlusVoices, basicVoices } from "./voices";
import { Badge } from "V2.0/common/badge";
import { FaCrown, FaStar } from "react-icons/fa6";

function TTSSettings({
  settings,
  syncAssistant,
  assistantId,
  workspaceId,
  proVoices,
  premiumVoices,
  superdashVoices,
  showPremiumOptions,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);

  const [errorMessage] = useState({});

  const template = useMemo(() => {
    const basicVoicesAsOptions = {
      label: "Basic",
      sticky: true,
      options: Object.keys(basicVoices).map((voice) => {
        return {
          id: voice,
          value: voice,
          label: basicVoices[voice].label,
        };
      }),
    };

    const basicPlusVoicesAsOptions = {
      label: "Basic+",
      sticky: true,
      options: Object.keys(basicPlusVoices).map((voice) => {
        return {
          id: voice,
          value: voice,
          label: basicPlusVoices[voice].label,
        };
      }),
    };

    const proVoicesAsOptions = {
      label: "Pro",
      labelNode: (
        <div>
          Pro{" "}
          <Badge color="orange">
            <FaStar />
          </Badge>
        </div>
      ),
      sticky: true,
      options: Object.keys(proVoices).map((voice) => {
        return {
          id: voice,
          value: voice,
          label: proVoices[voice].label,
        };
      }),
    };

    const superdashVoicesAsOptions = {
      label: "Pro+",
      sticky: true,
      options: Object.keys(superdashVoices).map((voice) => {
        return {
          id: voice,
          value: voice,
          label: superdashVoices[voice].label,
        };
      }),
    };

    const premiumVoicesAsOptions = {
      label: "Premium",
      labelNode: (
        <div>
          Premium{" "}
          <Badge color="amber">
            <FaCrown />
          </Badge>
        </div>
      ),
      sticky: true,
      options: Object.keys(premiumVoices).map((voice) => {
        return {
          id: voice,
          value: voice,
          label: premiumVoices[voice].label,
        };
      }),
    };

    return [
      {
        name: "voiceId",
        label: "Voice",
        type: "grouped-select",
        options: showPremiumOptions
          ? [basicVoicesAsOptions, basicPlusVoicesAsOptions, proVoicesAsOptions, superdashVoicesAsOptions, premiumVoicesAsOptions]
          : [basicVoicesAsOptions, basicPlusVoicesAsOptions, proVoicesAsOptions, superdashVoicesAsOptions],
      },
    ];
  }, [proVoices, premiumVoices, superdashVoices, showPremiumOptions]);
  const buttonInfo = { label: "Save", style: "right-side" };

  const schema = {
    voiceId: Joi.string().label("Voice"),
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await putTTSSettings({
        workspaceId,
        assistantId,
        payload: data,
      });
      if (response.status === 200) {
        message.success("Voice Changed");
        setLoading(false);
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            ttsSettings: response.data,
          };
        });
        onSuccess();
      }
    } catch (e) {
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to update voice",
      );
      setLoading(false);
      console.error("Error updating TTS settings");
    }
  };

  return (
    <div>
      <Form
        key={JSON.stringify(settings)}
        errorMessage={errorMessage}
        inputField={settings}
        template={template}
        schema={schema}
        onSubmit={handleSubmit}
        loading={loading}
        setLoading={setLoading}
        // getValue ={getInputValue}
        buttonInfo={buttonInfo}
      />
    </div>
  );
}

export { TTSSettings };
